module.exports = __webpack_public_path__ + "static/btn_028.e9f2bddc.png";